import { getAdjBasePrice, getPromotionalPrice } from './utils'

export type PrepareProduct = (args: {
  meta: { [key: string]: any }
  qty: number
  promotion: { [key: string]: any }
  viewType: string
}) => { [key: string]: any }

const getValueOrNull = (value) => value || null

export const prepareProduct: PrepareProduct = ({
  meta,
  qty,
  promotion,
  viewType,
}) => ({
  adj_base_price: meta?.locale === 'en_US' ? getAdjBasePrice(meta) : null,
  base_price: getValueOrNull(meta?.originalPrice || meta?.price),
  brand: getValueOrNull(meta?.brand),
  category: getValueOrNull(meta?.category),
  currency: getValueOrNull(meta?.currency),
  deal_description: getValueOrNull(promotion?.description),
  deal_id: getValueOrNull(promotion?.discountId),
  deal_name: getValueOrNull(promotion?.title),
  image_url: getValueOrNull(meta?.item?.imageUrl || meta?.item?.image),
  inventory_count: getValueOrNull(meta?.item?.inventoryCount),
  is_suggested: null,
  is_redemption: null,
  name: promotion?.itemName || null,
  packaging: getValueOrNull(meta?.item?.fullPackageDescription),
  points_earned: isNaN(Number(promotion?.score)) ? null : promotion.score,
  points_redeemed: null,
  price: getPromotionalPrice(meta),
  promotion_type: promotion?.type || promotion?.discountType || null,
  quantity: qty,
  quantity_type: viewType ? viewType : null,
  recommendation_id: null,
  recommendation_type: 'TOP_DEALS',
  recommended_quantity: null,
  units_per_quantity: viewType == 'pallets' ? meta?.palletQuantity : null,
  itemId: meta?.item?.itemId || meta?.item?.id || null,
  vendorItemId:
    meta?.item?.sourceData?.vendorItemId ||
    promotion?.sourceData?.vendorItemId ||
    null,
  is_mandatory_deal: null,
  max_quantity: null,
  expiration_date: null,
  page: null,
  page_item_count: null,
  sku: getValueOrNull(meta?.item?.sku),
  original_quantity: getValueOrNull(meta?.item?.minimumQuantity),
  is_default_recommendation: false,
  vendor_deal_id: getValueOrNull(meta?.item?.vendorDealId),
  vendorId: getValueOrNull(meta?.item?.vendorId),
  relevance_score: meta?.item?.score || null,
})

export default prepareProduct
